import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {ButtonSize, ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {DesignsFilter, DesignsFilterType} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsFilters';
import * as classnames from 'classnames/bind';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DesignsNotFound.less');
const cx = classnames.bind(styles);

enum OpsImageType
{
    Application = 'Application',
    Design = 'Design',
}

const OpsImages:{[key:string]:string} = {
    [OpsImageType.Application]: '/assets/images/home/ops_img_01.svg',
    [OpsImageType.Design]: '/assets/images/home/ops_img_02.svg',
};

interface Props
{
    filterType:DesignsFilterType;
    // newDesign?:boolean;
}

@observer
export class DesignsNotFound extends React.Component<Props, any>
{
    private _renderMessageBlock = (title:string, opsImageType:OpsImageType, body:JSX.Element):JSX.Element =>
    {
        const {isDesignsLoading} = rootState.ui.mainPage;

        if( isDesignsLoading ) return null;

        return (
            <div className={styles.block}>
                <img
                    className={styles.img}
                    src={OpsImages[opsImageType]}
                    alt=""
                />
                <div className={styles.title}>
                    {title}
                </div>
                <div className={styles.body}>
                    {body}
                </div>
            </div>
        );
    };

    private _onClickNewDesign = () =>
    {
        controllers.ui.dialogs.showDialog(Dialogs.AddDesign, false);
    };

    @computed
    private get _getGuidesLink():string
    {
        const guidesSpaces = rootState.data.projects
            .filter(space => space.designs && space.designs.some(design => design.isGuide));

        // assuming we may have several spaces with guide designs...
        return guidesSpaces.length ? `/spaces/${guidesSpaces[Math.floor(Math.random() * guidesSpaces.length)].id}` : null;
    }

    private _renderGuidesLink = ():JSX.Element =>
    {
        return  <div>
            <b>There are no applications yet.</b><br />
            Publish a design to create one, or <a className={cx('link')}
                onClick={() => controllers.navigation.navigateTo(this._getGuidesLink)}
            > see guides to learn more
            </a>.
        </div>
    }

    private _renderNoApplications = ():JSX.Element =>
    {
        return this._renderMessageBlock('Publish your design', OpsImageType.Application, (
            this._getGuidesLink ? this._renderGuidesLink() : 
                <div>
                <b>There are no applications yet.</b><br />
                Publish a design to create one.<br />
            </div>
        ));
    };

    private _renderNoPublished = ():JSX.Element =>
    {
        return this._renderMessageBlock('Publish your design', OpsImageType.Design, (
            <div>
                <b>There are no published designs yet.</b><br />
                Publish a design to create one, or <a className={cx('link')}
                    onClick={() => controllers.navigation.navigateTo(this._getGuidesLink)}
                >
                    see guides to learn more
                </a>.
            </div>
        ));
    };

    private _renderNoDesigns = ():JSX.Element =>
    {
        const {filterType} = this.props;

        return this._renderMessageBlock('Get started', OpsImageType.Design, (
            <div>
                <b>There are no designs yet.</b><br />
                Create a new one to express your ideas, or <a className={cx('link')}
                    onClick={() => controllers.navigation.navigateTo('/templates')}
                >
                    start from templates
                </a>.
                {
                    // (filterType !== DesignsFilterType.Designs && filterType !== DesignsFilterType.HomeDesigns) &&
                    <div className={styles.btnWrapper}>
                        <WSPButton
                            className={styles.btnNewDesign}
                            caption={'Create a design'}
                            style={ButtonStyle.Raised}
                            size={ButtonSize.Large}
                            onClick={this._onClickNewDesign}
                        />
                    </div>
                }
            </div>
        ));
    };

    render():JSX.Element | null
    {
        const {filterType} = this.props;

        const designsFilter = controllers.ui.mainPage.getDesignsFilter(filterType);

        switch( filterType )
        {
            case DesignsFilterType.SearchDesigns:
            case DesignsFilterType.SearchApplications:

                const searched:boolean = !!controllers.ui.mainPage.getDesignsSearchString();

                if( !searched ) return null;

                let objectType:string = '';
                let opsImageType:OpsImageType;

                if( designsFilter === DesignsFilter.Published )
                {
                    objectType = 'applications';
                    opsImageType = OpsImageType.Application;
                }
                else
                {
                    objectType = 'designs';
                    opsImageType = OpsImageType.Design;
                }

                return this._renderMessageBlock('Ops!', opsImageType, (
                    <div>
                        <b>0 Matching {objectType}</b><br />
                        Please search using another term or keyword
                    </div>
                ));

            case DesignsFilterType.HomeDesigns:

                return this._renderNoDesigns();

            case DesignsFilterType.Applications:
            case DesignsFilterType.HomeApplications:

                return this._renderNoApplications();

            case DesignsFilterType.Designs:
            case DesignsFilterType.Spaces:

                if( designsFilter === DesignsFilter.Published )
                    return this._renderNoPublished();
                else
                    return this._renderNoDesigns();

            default:
                return null;
        }
    }
}
